import { useEffect, useState } from "react";
import { getRelatedCxItem } from "../../../../../../Api";
import { useAuth0 } from "@auth0/auth0-react";
import { Box, Modal } from "@mantine/core";
import CallTextArea from "../Gong-call/CallTextArea";
import { stripHtml } from "../../../../../../utils";
import EngagementNotesTitle from "./EngagementNotesTitle";

const EngagementNotes = ({item}:{item: any}) => {
  const auth0 = useAuth0()
  const [engagemntNotesItem, setEngagementNotesItem] = useState<any>({})
  const [opened, setOpened] = useState(false);

  const excerptsArr: any [] =  item?.excerpts || [];

  const highlightExcerpts = (html: string, excerpts: any[]) => {
    if (!html || !excerpts.length) return html;
    
    let processedHtml = html;
    // Sort excerpts by start position in reverse order to avoid position shifting
    const sortedExcerpts = [...excerpts].sort((a, b) => b.excerptFirstChar - a.excerptFirstChar);
    
    sortedExcerpts.forEach(excerpt => {
      const start = excerpt.excerptFirstChar;
      const end = excerpt.excerptLastChar;
      const text = processedHtml.substring(start, end);
      const highlightedText = `<span style="background-color: #FFF9A0;">${text}</span>`;
      processedHtml = processedHtml.substring(0, start) + highlightedText + processedHtml.substring(end);
    });
    
    return processedHtml;
  };

  const loadGongCall = (cxItemIdForGong: string) => {
    getRelatedCxItem(cxItemIdForGong, auth0)
      .then((res) => {
        setEngagementNotesItem(res)
      })
      .catch((e) => console.log(e));
  };

  const title = engagemntNotesItem?.PMEngagementSummary
  const participants = engagemntNotesItem?.PMEngagementParticipants
  const engagementDetails = engagemntNotesItem?.PMEngagementDetails

  const processedEngagementDetails = highlightExcerpts(engagementDetails, excerptsArr);

  const combinedContent = `
    <div class="participants-section">
      <h3>Participants</h3>
      ${participants || ''}
    </div>
    <div class="details-section">
      <h3>Engagement Details</h3>
      ${processedEngagementDetails || ''}
    </div>
  `;

  useEffect(() => {
    if (item?.cxItemId) {
      loadGongCall(item?.cxItemId);
    }
  }, [item]);

  return (
    <Box mt={15}>
      {opened && <Modal
        opened={opened}
        centered
        onClose={() => setOpened(false)}
        size="750px"
        padding={0}
        styles={{
          close: {
            marginRight: "40px",
            marginTop: "16px",
            
          },
        }}
        title={<EngagementNotesTitle cxItem={engagemntNotesItem} origin={engagemntNotesItem?.origin || 'N/A'}/>}
      >
        
        <Box pl={36} h={600} pb={8} style={{ height: '100%',  overflow: 'hidden',
          position: 'relative' }}>
          <iframe
            srcDoc={`<html><head><style>
                body {
                  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
                  font-size: 14px;
                  line-height: 1.5;
                  margin: 0;
                  min-height: 95%;
                  padding-right: 46px;
                }
                html {
                  height: 95%;
                }
                
                h3 {
                  
                  color: #5A5A5A;
                }
              </style></head><body>${combinedContent}</body></html>`}
            style={{ 
              width: '100%', 
              border: 'none', 
              height: '100%',
              minHeight: '470px' // 542px - 36px padding - 36px padding
            }}
            title="Engagement Content"
          />
        </Box>
       
      </Modal>}
      <CallTextArea
        title={title}
        text={stripHtml(processedEngagementDetails)}
        mlData={item?.ml}
        excerptsArr={excerptsArr}
        setOpened={setOpened}
        type='notes'
      /> 
    </Box>
  )
}

export default EngagementNotes